export const formatString=(text)=>{
    return text.replace(/\u00A0/g, " ")
}